export default "__VITE_ASSET__Jt1MFvR5__"